<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<!--<el-form-item v-if="Limits.user_create">-->
					<!--<el-button type="primary" size="small" icon="el-icon-plus" @click="addmore">添加管理账户</el-button>-->
				<!--</el-form-item>-->
				<!--<el-form-item>-->
					<!--<el-input v-model="SearchName" placeholder="请输入用户名" prefix-icon="el-icon-search" size="small"></el-input>-->
				<!--</el-form-item>-->
				<!--<el-form-item>-->
					<!--<el-button type="primary" size="small" @click="Find" icon="el-icon-search">查询</el-button>-->
				<!--</el-form-item>-->
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
		    <el-table-column prop="username" label="用户名"></el-table-column>
		    <el-table-column prop="nickname" label="姓名"></el-table-column>
		    <!--<el-table-column prop="dealer.name" label="经销商"></el-table-column>-->
		    <el-table-column prop="role.name" label="角色"></el-table-column>
		    <el-table-column label="操作" width="120">
		    	<template slot-scope="scope">
		    		<el-button v-if="Limits.user_update && (scope.row.username != userName)" type="primary" icon="el-icon-edit" size="mini" style="padding: 7px;" @click="Getchange(scope.$index,scope.row)"></el-button>
		    		<el-button v-if="Limits.user_status && (scope.row.username != userName)" type="danger" size="mini" style="padding: 7px;" @click="Delete(scope.$index,scope.row)">禁用</el-button>
		    	</template>
		    </el-table-column>
  		</el-table>

  		<el-col :span="24" class="toolbar downtool">
  			<el-button v-if="Limits.user_status" type="primary" size="small" @click="ShowDeleted">查看已禁用账户</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>


		<!--添加账户-->
		<el-dialog title="添加管理账户" :visible.sync="AddFormVisible" width="50%" center>
			<el-dialog :fullscreen="true" title="创建新角色" :visible.sync="innerVisible" append-to-body center>
				<el-form :model="form2">
					<el-form-item label="角色名：" :label-width="formLabelWidth">
						<el-input placeholder="请填写角色名称(必填)" v-model="form2.CharacterName" auto-complete="off"></el-input>
		    		</el-form-item>
		    		<el-form-item v-for="item in roledata.permissions" :key="item.group" :label="item.group" :label-width="formLabelWidth">
			    		<el-checkbox-group v-model="form2.role">
						    <el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}</el-checkbox>
						</el-checkbox-group>
			    	</el-form-item>
    			</el-form>
    			<div slot="footer" class="dialog-footer">
		    		<el-button size="small" type="primary" @click="UpCharacter" :loading="createloading" style="padding: 10px 50px;">提 交</el-button>
		  		</div>
			</el-dialog>
		  	<el-form :model="form">
			    <el-form-item label="经销商：" :label-width="formLabelWidth">
			      	<el-select v-model="form.dealer" placeholder="请选择上级经销商">
			        	<el-option v-for="ite in Dealerlist" :key="ite.id" :label="ite.name" :value="ite.id"></el-option>
			      	</el-select>
			    </el-form-item>
			    <el-form-item label="用户名：" :label-width="formLabelWidth">
		      		<el-input placeholder="请填写用户名(必填)" v-model="form.person" auto-complete="off"></el-input>
		    	</el-form-item>
		    	<el-form-item label="密码：" :label-width="formLabelWidth">
		      		<el-input placeholder="请填写密码(必填)" v-model="form.pass" auto-complete="off"></el-input>
		    	</el-form-item>
		    	<el-form-item label="角色：" :label-width="formLabelWidth">
		    		<el-select v-model="form.character" placeholder="请选择角色">
			        	<el-option v-for="Citem in Roleslist" :key="Citem.name" :label="Citem.name" :value="Citem.name"></el-option>
			      	</el-select>
			      	<el-button type="primary" size="small" icon="el-icon-plus" @click="AddCharacter">增加角色</el-button>
		    	</el-form-item>
		  	</el-form>
		  	<div slot="footer" class="dialog-footer">
		    	<el-button size="small" type="primary" @click="Upload" style="padding: 10px 50px;" :loading="createidloading">提 交</el-button>
		  	</div>
		</el-dialog>

		<!--已禁用账户-->
		<el-dialog title="已禁用账户" :visible.sync="DeleteVisible" :fullscreen="true" :before-close="Backchange">
			<div>
			<el-table :data="List2" border v-loading="listloading2">
			    <el-table-column prop="username" label="用户名"></el-table-column>
			    <el-table-column prop="dealer.name" label="经销商"></el-table-column>
			    <el-table-column prop="role.name" label="角色"></el-table-column>
			    <el-table-column label="操作" width="80" v-if="Limits.user_status">
			    	<template slot-scope="scope">
			    		<el-button type="success" size="mini" style="padding: 7px;" @click="Open(scope.$index,scope.row)">启用账户</el-button>
			    	</template>
			    </el-table-column>
  			</el-table>

  			<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
			</el-pagination>
			</el-col>
			</div>
		</el-dialog>
		<!--更改账户信息-->
		<el-dialog title="更改账户信息" :visible.sync="ChangeFormVisible" width="50%" center>
			<el-dialog :fullscreen="true" title="创建新角色" :visible.sync="innerVisible" append-to-body center>
				<el-form :model="form2">
					<el-form-item label="角色名：" :label-width="formLabelWidth">
						<el-input placeholder="请填写角色名称(必填)" v-model="form2.CharacterName" auto-complete="off"></el-input>
		    		</el-form-item>
		    		<el-form-item v-for="item in roledata.permissions" :key="item.group" :label="item.group" :label-width="formLabelWidth">
			    		<el-checkbox-group v-model="form2.role">
						    <el-checkbox v-for="it in item.items" :key="it.value" :label="it.value">{{it.label}}</el-checkbox>
						</el-checkbox-group>
			    	</el-form-item>
    			</el-form>
    			<div slot="footer" class="dialog-footer">
		    		<el-button size="small" type="primary" @click="UpCharacter" :loading="createloading" style="padding: 10px 50px;">提 交</el-button>
		  		</div>
			</el-dialog>
		  	<el-form :model="form3">
			    <!--<el-form-item label="经销商：" :label-width="formLabelWidth">-->
			      	<!--<el-select v-model="form3.dealer" placeholder="请选择上级经销商">-->
			        	<!--<el-option v-for="ite in Dealerlist" :key="ite.id" :label="ite.name" :value="ite.id"></el-option>-->
			      	<!--</el-select>-->
			    <!--</el-form-item>-->
			    <!--<el-form-item label="用户名：" :label-width="formLabelWidth">-->
		      		<!--<el-input placeholder="请填写联系人(必填)" v-model="form3.person" auto-complete="off"></el-input>-->
		    	<!--</el-form-item>-->
		    	<!--<el-form-item label="密码：" :label-width="formLabelWidth">
		      		<el-input placeholder="请填写电话(必填)" v-model="form3.pass" auto-complete="off"></el-input>
		    	</el-form-item>-->
		    	<el-form-item label="角色：" :label-width="formLabelWidth">
		    		<el-select v-model="form3.character" placeholder="请选择角色">
			        	<el-option v-for="Citem in Roleslist" :key="Citem.name" :label="Citem.name" :value="Citem.name"></el-option>
			      	</el-select>
			      	<el-button type="primary" size="small" icon="el-icon-plus" @click="AddCharacter">增加角色</el-button>
		    	</el-form-item>
		  	</el-form>
		  	<div slot="footer" class="dialog-footer">
		    	<el-button size="small" type="primary" @click="ChangeUpload" style="padding: 10px 50px;" :loading="createidloading">提 交</el-button>
		  	</div>
		</el-dialog>
	</div>
</template>

<script>
	import {GetUserslist,GetPermissionslist,GetDealerlist,GetRoleslist} from '../api/api';

	export default {
		data(){
			return {
				token:"",
				maxHeight:300,
				Limits:"",
				userName:"",
				SearchName:"",
				List:[],
				listloading:false,
				createloading:false,
				createidloading:false,
				Pagesize:20,
				Curpage:1,
				total:1,
				AddFormVisible:false,
				ChangeFormVisible:false,
				formLabelWidth:"100px",
				form:{
					dealer:"",
					person:"",
					character:"",
					pass:"",
				},
				form3:{
					// dealer:"",
					// person:"",
					character:"",
//					pass:"",
				},
				Form:{
					id:"",
					username:"",
					dealer:{
						id:""
					},
					role:{
						name:"",
					}
				},
				Delloading:false,
				List2:[],
				listloading2:false,
				Pagesize2:20,
				Curpage2:1,
				total2:1,
				DeleteVisible:false,
				innerVisible:false,
				quantity:1,
				roledata:[],
				Dealerlist:[],
				Roleslist:[],
				form2:{
					CharacterName:"",
					role:[]
				}
			}
		},
		methods:{
			AddCharacter(){
				this.innerVisible = true
				this.Getrole()
			},
			UpCharacter(){
				console.log(this.form2.role)
				if(this.form2.CharacterName){
					let url = "/roles?token=" + this.token
					this.createloading = true
					this.axios.post(url,{"name":this.form2.CharacterName,"permissions":this.form2.role}).then(res => {
						console.log(res)
						if(res.status == "200"){
							this.$message({
					            type: 'success',
					            message: '操作成功!'
					        });
					        this.innerVisible = false
					        this.createloading = false
					        this.Getroles()
					        this.form.character = this.form2.CharacterName
					        this.form3.character = this.form2.CharacterName
						}
						else{
							this.$message.error('对不起，请求失败。')
							this.createloading = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.createloading = false
					})
				}
			},
			addmore(){
				this.AddFormVisible = true
				this.form.dealer = ""
				this.form.person = ""
				this.form.character = ""
				this.form.pass = ""
				this.GetDealerList(GetDealerlist)
			},
			Find(){
				if(this.SearchName){
					this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"username":"~"+this.SearchName,"status":"10"}}])})
				}
			},
			Refresh(){
				this.Curpage = 1
				this.SearchName = ""
				this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
			},
			handleCurrentChange(val){
				this.Curpage = val
				if(this.SearchName){
					this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"username":"~"+this.SearchName,"status":"10"}}])})
				}else{
					this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
				}
			},
			Delete(index,row){
				this.$confirm('确认禁用该账户?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	this.listloading = true
					this.Form = Object.assign({}, row);
					let u = '/users/'+this.Form.id+"/status?token="+this.token
					this.axios.put(u,{status:"0"}).then(res => {
						if(res.status == "200"){
							this.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
				          	this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
						}else{
							this.$message.error('对不起，请求失败。')
							this.listloading = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.listloading = false
					})
			    }).catch(()=>{
			    	this.$message({
			        	type: 'info',
			            message: '已取消禁用'
			        });
			        this.listloading = false
			    })
			},
			ShowDeleted(){
				this.quantity = 1
				this.DeleteVisible = true
				this.GetList2(GetUserslist,{page:this.Curpage2,token:this.token,q:JSON.stringify([{"AND":{"status":"0"}}])})
			},
			Open(index,row){
				this.listloading2 = true
				this.Form = Object.assign({}, row);
				let ud = '/users/' + this.Form.id + "/status?token=" + this.token
				this.axios.put(ud,{status:"10"}).then(res => {
						if(res.status == "200"){
							this.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
				          	this.quantity = 2
				          	this.GetList2(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"0"}}])})
						}else{
							this.$message.error('对不起，请求失败。')
							this.listloading2 = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.listloading2 = false
					})

			},
			handleCurrentChange2(val){
				this.Curpage2 = val
				this.GetList2(GetUserslist,{page:this.Curpage2,token:this.token,q:JSON.stringify([{"AND":{"status":"0"}}])})
			},
			Backchange(){
				if(this.quantity == 2){
					this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
				}
				this.DeleteVisible = false
			},
			Getrole(){
				GetPermissionslist({token:this.token}).then(res => {
					console.log("res",res.data)
					this.roledata = res.data.items
				}).catch(err => {
					console.log(err)
				})
			},
			Getroles(){
				this.axios.get("/roles",{params:{
					token:this.token,
					fields:"name"
				}}).then(res => {
					console.log(res)
					this.Roleslist = res.data.items
				}).catch(err => {
					this.$message.error(err.response.data.message)
				})
			},
			Upload(){
				if(this.form.person && this.form.pass && this.form.dealer && this.form.character){
					this.createidloading = true
					let url = "/users?token=" + this.token
					this.axios.post(url,{
						"username":this.form.person,
						"password":this.form.pass,
						"dealer":this.form.dealer,
						"role":this.form.character,
					}).then(res => {
						console.log(res)
						if(res.status == "201"){
							this.$message({
				            	type: 'success',
				            	message: '操作成功!'
				          	});
							this.AddFormVisible = false
							this.createidloading = false
							this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
						}else{
							this.$message.error('对不起，请求失败。')
							this.createidloading = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.createidloading = false
					})
				}else{
					this.$message.error('请完善信息后再次提交。')
				}
			},
			Getchange(index,row){
				this.ChangeFormVisible = true
				this.GetDealerList(GetDealerlist)
				this.Form = Object.assign({}, row);
				// this.form3.dealer = this.Form.dealer.id
				// this.form3.person = this.Form.username
				this.form3.character = this.Form.role.name
			},
			ChangeUpload(){
				// if(this.form3.person && this.form3.dealer && this.form3.character){
				if(this.form3.character){
					this.createidloading = true
					let url = "/users/"+this.Form.id+"?token=" + this.token
					this.axios.put(url,{
						// "username":this.form3.person,
						// "dealerId":this.form3.dealer,
						"role":this.form3.character,
					}).then(res => {
						console.log(res)
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
						this.ChangeFormVisible = false
						this.createidloading = false
						this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.createidloading = false
					})
				}else{
					this.$message.error('请完善信息后再次提交。')
				}
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.userName = sessionStorage.getItem("user")
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList(GetUserslist,{page:this.Curpage,token:this.token,q:JSON.stringify([{"AND":{"status":"10"}}])})
			this.Getroles()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})

		}
	}

</script>

<style scoped>
.el-checkbox+.el-checkbox {
	margin-left: 30px;
}
</style>


// WEBPACK FOOTER //
// AccountManagement.vue?5eaef9b4